import { FormattedMessage } from "react-intl";

export const PUBLICATIONS_PERIODIC_TYPES = {
  YEAR: "YEAR",
  HALF_YEAR: "HALF-YEAR",
  QUARTER: "QUARTER",
  MONTH: "MONTH",
};
export const PERIODIC_CONST = [
  {
    id: 1,
    type: [PUBLICATIONS_PERIODIC_TYPES.YEAR, PUBLICATIONS_PERIODIC_TYPES.MONTH],
  },
  {
    id: 2,
    type: [PUBLICATIONS_PERIODIC_TYPES.YEAR, PUBLICATIONS_PERIODIC_TYPES.MONTH],
  },
  {
    id: 3,
    type: [
      PUBLICATIONS_PERIODIC_TYPES.YEAR,
      PUBLICATIONS_PERIODIC_TYPES.QUARTER,
    ],
  },
  {
    id: 4,
    type: [
      PUBLICATIONS_PERIODIC_TYPES.YEAR,
      PUBLICATIONS_PERIODIC_TYPES.HALF_YEAR,
    ],
  },
  { id: 5, type: [PUBLICATIONS_PERIODIC_TYPES.YEAR] },
  { id: 6, type: [PUBLICATIONS_PERIODIC_TYPES.YEAR] },
  { id: 7, type: [PUBLICATIONS_PERIODIC_TYPES.YEAR] },
  { id: 8, type: [PUBLICATIONS_PERIODIC_TYPES.YEAR] },
  {
    id: 9,
    type: [PUBLICATIONS_PERIODIC_TYPES.YEAR, PUBLICATIONS_PERIODIC_TYPES.MONTH],
  },
];
export const QUARTER_YEAR_CONST = [
  { value: 1, labelId: "firstQuarter" },
  { value: 2, labelId: "secondQuarter" },
  { value: 3, labelId: "thirdQuarter" },
  { value: 4, labelId: "fourthQuarter" },
];

export const HALF_YEAR_CONST = [
  { value: 2, labelId: "firstHalf" },
  { value: 4, labelId: "secondHalf" },
];
